import moment from "moment";
import { configurations } from "../../../configurations";

function CustomerDetailActivityLog({ log }) {
  const icon = () => {
    switch (log?.type) {
      case configurations.services.flight.code:
        return "/IconFlight2.svg";
      case configurations.services.stay.code:
        return "/IconHotel2.svg";
      case configurations.services.insurance.code:
        return "/IconTour2.svg";
      case configurations.services.insurance.code:
        return "/IconInsurance2.svg";
      default:
        return "/IconActivity.svg";
    }
  };

  return (
    <div className="w-full flex flex-col pb-3 border-b border-gray-300">
      <small className="text-[#6D7C94] mb-1">
        {moment(log?.createdAt).format("DD MMM YYYY")}{" "}
        {moment(log?.createdAt).format("HH:MM A")}
      </small>
      <div className="flex gap-2">
        <img src={icon()} className="w-4 h-4 object-contain mt-1" alt="" />
        <div className="text-sm flex flex-1 flex-col">
          {/* John Doe booked a flight: LOS - LHR with reference no:{" "} */}
          <span>{log.action}</span>
          <small className="text-gray-600">{log.details}</small>
          {/* {log?.details} */}
          {/* <span className="text-[#0BCEB2]">BK389240</span> */}
        </div>
      </div>
    </div>
  );
}

export default CustomerDetailActivityLog;
